module.exports = __webpack_public_path__ + "assets/EquilateralOnCCDetailed.53d4652d6ff4d4c5337537adf876f4c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/EquilateralOnCCDetailed.png
// module id = 512
// module chunks = 0